import React, { createContext, useContext, useState } from 'react';

const ReturnManifestDetailContext = createContext(null);

const ReturnManifestDetailProvider = ({ children }) => {
  const [returnManifestStatus, setReturnManifestStatus] = useState('');
  const [editingShipments, setEditingShipments] = useState({});
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  // Add a shipment to editing state
  const startEditing = shipmentId => {
    setEditingShipments(prev => ({
      ...prev,
      [shipmentId]: true,
    }));

    setHasUnsavedChanges(true);
  };

  // Remove a shipment from editing state after save
  const finishEditing = shipmentId => {
    setEditingShipments(prev => {
      const newState = { ...prev };
      delete newState[shipmentId];

      // If no more shipments are being edited, clear unsaved changes flag
      if (Object.keys(newState).length === 0) {
        setHasUnsavedChanges(false);
      }

      return newState;
    });
  };

  // Reset all editing state
  const resetEditing = () => {
    setEditingShipments({});
    setHasUnsavedChanges(false);
  };

  return (
    <ReturnManifestDetailContext.Provider
      value={{
        returnManifestStatus,
        setReturnManifestStatus,
        editingShipments,
        hasUnsavedChanges,
        startEditing,
        finishEditing,
        resetEditing,
      }}
    >
      {children}
    </ReturnManifestDetailContext.Provider>
  );
};

export const useReturnManifestDetailContext = () =>
  useContext(ReturnManifestDetailContext);

export default ReturnManifestDetailProvider;
